const SYMBOLS: Record<string, string> = {
  RUB: '₽',
  USD: '$',
  EUR: '€',
  GBP: '£',
  KZT: '₸',
  UAH: '₴',
  TRY: '₺',
  BYN: 'Br',
};

export function formatPrice(price: number | null, currency: string | null): string | null {
  if (price === null || price === undefined) return null;
  const amount = new Intl.NumberFormat('ru-RU', {
    maximumFractionDigits: price % 1 === 0 ? 0 : 2,
  }).format(price);
  if (!currency) return amount;
  return `${amount} ${SYMBOLS[currency] ?? currency}`;
}

export function formatDate(iso: string): string {
  return new Intl.DateTimeFormat('ru-RU', {
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(iso));
}

/**
 * Доля 0..1 в проценты. Ниже одного процента округление до целого даёт «0%»
 * там, где переходы всё-таки были, — такой случай показываем отдельно.
 */
export function formatPercent(value: number): string {
  if (value > 0 && value < 0.01) return '<1%';
  return `${Math.round(value * 100)}%`;
}

export function plural(n: number, forms: [string, string, string]): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return forms[0];
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return forms[1];
  return forms[2];
}
